import axios from "axios";
import { baseUrl } from "../util";

class EFRAGService {
  constructor() {
    this.baseURL = baseUrl;
    this.efragConverterURL =
      "https://www.efrag.org/en/vsme-digital-template-and-xbrl-taxonomy";
  }

  // Upload Excel file to EFRAG converter
  async uploadToEFRAGConverter(excelBlob, templateType = "VSME") {
    try {
      const formData = new FormData();
      formData.append("file", excelBlob, "efrag-template.xlsx");
      formData.append("templateType", templateType);

      // Since we can't directly call EFRAG's API, we'll need to handle this server-side
      const response = await axios.post(
        `${this.baseURL}/api/business/efrag/upload/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error uploading to EFRAG converter:", error);
      throw error;
    }
  }

  // Process EFRAG conversion on the backend
  async processEFRAGConversion(fileId, conversionOptions = {}) {
    try {
      const response = await axios.post(
        `${this.baseURL}/api/business/efrag/convert/`,
        {
          fileId,
          options: {
            outputFormat: conversionOptions.outputFormat || "xbrl",
            includeValidation: conversionOptions.includeValidation !== false,
            ...conversionOptions,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error processing EFRAG conversion:", error);
      throw error;
    }
  }

  // Get conversion status
  async getConversionStatus(conversionId) {
    try {
      const response = await axios.get(
        `${this.baseURL}/api/business/efrag/status/${conversionId}/`
      );
      return response.data;
    } catch (error) {
      console.error("Error getting conversion status:", error);
      throw error;
    }
  }

  // Download converted report
  async downloadConvertedReport(conversionId) {
    try {
      const response = await axios.get(
        `${this.baseURL}/api/business/efrag/download/${conversionId}/`,
        { responseType: "blob" }
      );

      return response.data;
    } catch (error) {
      console.error("Error downloading converted report:", error);
      throw error;
    }
  }

  // Generate XBRL report from table data
  async generateXBRLReport(tableData, reportMetadata = {}) {
    try {
      const response = await axios.post(
        `${this.baseURL}/api/business/efrag/generate-xbrl/`,
        {
          data: tableData,
          metadata: {
            reportingDate:
              reportMetadata.reportingDate || new Date().toISOString(),
            entityName: reportMetadata.entityName || "Company",
            currency: reportMetadata.currency || "EUR",
            ...reportMetadata,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error generating XBRL report:", error);
      throw error;
    }
  }

  // Validate EFRAG compliance
  async validateEFRAGCompliance(data) {
    try {
      const response = await axios.post(
        `${this.baseURL}/api/business/efrag/validate/`,
        {
          data,
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error validating EFRAG compliance:", error);
      throw error;
    }
  }
}

export default new EFRAGService();
